export default "__VITE_ASSET__BraSe7u2__"